import {Action} from "@ngrx/store";
import {Website} from '../../websites/website/website';
import {BuilderTemplates} from "../../websites/website/builder-templates/builder-templates";

export const LOAD_BUILDER_TEMPLATES: string = '[website] Load Builder Templates';
export const LOAD_BUILDER_TEMPLATES_SUCCESS: string = '[website] Load Builder Templates Success';
export const LOAD_BUILDER_TEMPLATES_FAIL: string = '[website] Load Builder Templates Fail';
export const LOAD_LAST_BUILDER_TEMPLATE: string = '[website] Load Last Builder Template';
export const LOAD_LAST_BUILDER_TEMPLATE_SUCCESS: string = '[website] Load Last Builder Template Success';
export const LOAD_LAST_BUILDER_TEMPLATE_FAIL: string = '[website] Load Last Builder Template Fail';
export const LOAD_BUILDER_TEMPLATES_CATEGORIES: string = '[website] Load Builder Templates Categories';
export const LOAD_BUILDER_TEMPLATES_CATEGORIES_SUCCESS: string = '[website] Load Builder Templates Categories Success';
export const LOAD_BUILDER_TEMPLATES_CATEGORIES_FAIL: string = '[website] Load Builder Templates Categories Fail';
export const LOAD_IMPORTING_BUILDER_TEMPLATE: string = '[website] Load Importing Builder Template';
export const LOAD_IMPORTING_BUILDER_TEMPLATE_SUCCESS: string = '[website] Load Importing Builder Template Success';
export const LOAD_IMPORTING_BUILDER_TEMPLATE_FAIL: string = '[website] Load Importing Builder Template Fail';

export class LoadBuilderTemplates implements Action {

  readonly type: string = LOAD_BUILDER_TEMPLATES;

}

export class LoadBuilderTemplatesSuccess implements Action {

  readonly type: string = LOAD_BUILDER_TEMPLATES_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: Website
  }) {}

}

export class LoadBuilderTemplatesFail implements Action {

  readonly type: string = LOAD_BUILDER_TEMPLATES_FAIL;
  constructor(public payload: string) {}

}

export class LoadLastBuilderTemplate implements Action {

  readonly type: string = LOAD_LAST_BUILDER_TEMPLATE;
  constructor(public payload: {
    websiteId: number,
    lastEntities: BuilderTemplates
  }) {}
}


export class LoadLastBuilderTemplateSuccess implements Action {

  readonly type: string = LOAD_LAST_BUILDER_TEMPLATE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    lastEntities: BuilderTemplates
  }) {}

}

export class LoadLastBuilderTemplateFail implements Action {

  readonly type: string = LOAD_LAST_BUILDER_TEMPLATE_FAIL;
  constructor(public payload: string) {}

}


export class LoadBuilderTemplatesCategories implements Action {
  readonly type: string = LOAD_BUILDER_TEMPLATES_CATEGORIES;
}


export class LoadBuilderTemplatesCategoriesSuccess implements Action {

  readonly type: string = LOAD_BUILDER_TEMPLATES_CATEGORIES_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: Website
  }) {}

}

export class LoadBuilderTemplatesCategoriesFail implements Action {

  readonly type: string = LOAD_BUILDER_TEMPLATES_CATEGORIES_FAIL;
  constructor(public payload: string) {}

}


export class LoadImportingBuilderTemplate implements Action {
  readonly type: string = LOAD_IMPORTING_BUILDER_TEMPLATE;
  constructor(public payload: {
    website: Website,
    templateId: number,
    templateType: string,
    templateTitle: string
    postStatus: string,
    kitData?: any,
    menuTermId?: string,
    menuItemId?: string,
    menuItemPosition?: string,
  }) {}
}


export class LoadImportingBuilderTemplateSuccess implements Action {

  readonly type: string = LOAD_IMPORTING_BUILDER_TEMPLATE_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: Website
  }) {}

}

export class LoadImportingBuilderTemplateFail implements Action {

  readonly type: string = LOAD_IMPORTING_BUILDER_TEMPLATE_FAIL;
  constructor(public payload: string) {}

}

export type BuilderTemplatesAction = LoadBuilderTemplates | LoadBuilderTemplatesSuccess | LoadBuilderTemplatesFail | LoadLastBuilderTemplate | LoadLastBuilderTemplateSuccess | LoadLastBuilderTemplateFail | LoadBuilderTemplatesCategories | LoadBuilderTemplatesCategoriesSuccess | LoadBuilderTemplatesCategoriesFail | LoadImportingBuilderTemplate | LoadImportingBuilderTemplateSuccess | LoadImportingBuilderTemplateFail;
